import { format, parseISO } from "date-fns";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { Profile } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import { AddRow, ProfileSection } from "../profilePrimitives";

export function ReferralsSection({
    referrals,
    setOverlay,
}: {
    referrals: Profile["referrals"];
    setOverlay: OpenProfileOverlay;
}) {
    if (!referrals) return null;

    const canStartPromotion = !referrals.promotions.some(
        (promotion) => promotion.status === "active",
    );

    return (
        <ProfileSection title="Referrals">
            {referrals.promotions.map((promotion) => (
                <Button
                    key={promotion.id}
                    type="button"
                    variant="ghost"
                    className="-mx-2 h-auto flex-col items-start gap-0.5 rounded-md px-2 py-1"
                    onClick={() => setOverlay({ type: "referral", promotion })}
                >
                    <p className="heading-5 text-zinc-900">
                        {format(parseISO(promotion.date), "d MMM yyyy")}
                    </p>
                    <div className="flex items-center gap-1.5">
                        <p className="text-2xs text-zinc-500 leading-3">
                            {promotion.status === "active" ? "In progress" : "Ended"}
                        </p>
                        {promotion.status !== "active" && (
                            <Badge
                                variant={
                                    promotion.status === "successful"
                                        ? "green"
                                        : "secondary"
                                }
                                size="sm"
                            >
                                {promotion.status === "successful"
                                    ? "Successful"
                                    : "Unsuccessful"}
                            </Badge>
                        )}
                    </div>
                </Button>
            ))}
            {canStartPromotion && (
                <AddRow
                    label="Start a new promotion"
                    onClick={() => setOverlay({ type: "referral" })}
                />
            )}
        </ProfileSection>
    );
}
